<template>
  <div class="box-body">
    <div class="row m-b-15">
      <div class="row center-block">
        <div class="col-md-12">
          <div>
            <br />
            <div class="box-body form-left">
              <div>
                <div class="input-group">
                  <span class="input-group-addon">活動名稱(後台)</span>
                  <input class="form-control" placeholder="" type="text" v-model="menuName" maxlength="45">
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">活動名稱(前端)</span>
                  <input class="form-control" placeholder="" type="text" v-model="menuName" maxlength="45">
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">活動說明(後台)</span>
                  <input class="form-control" placeholder="" type="text" v-model="menuId" maxlength="45">
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">活動說明(前端)</span>
                  <input class="form-control" placeholder="" type="text" v-model="menuId" maxlength="45">
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">活動順序</span>
                  <input class="form-control" placeholder="" type="text" v-model="menuId" maxlength="45">
                </div>
                <br />
              </div>
            </div>
            <div class="box-body form-right">
              <div>
                <div class="input-group cr-schedule">
                          <span class="input-group-addon">
                            <span class="text-red">＊ </span>活動開始時間
                          </span>
                  <date-time-picker :date="menuTime.start" :option="timeoption" :limit="startLimit"></date-time-picker>
                  <!--<input class="form-control w-200" placeholder="" type="text" v-model="menuTime.start">-->
                </div>
                <br />
              </div>
              <div>
                <div class="input-group cr-schedule">
                  <span class="input-group-addon">
                    <span class="text-red">＊ </span>活動結束時間
                  </span>
                  <date-time-picker :date="menuTime.end" :option="timeoption" :limit="endLimit"></date-time-picker>
                  <!--<input class="form-control w-200" placeholder="" type="text" v-model="menuTime.end">-->
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">
                    會員限制
                  </span>
                  <multiselect
                    v-model="memberLimit"
                    :options="memberType"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="會員限制"
                    label="label"
                    track-by="label"
                  >
                  </multiselect>
                </div>
                <br />
              </div>
            </div>
            <!--
            <div class="col-xs-12 p-sm-10-p m-x-10 form-left">
              <div>
                <div class="input-group">
                    <span class="input-group-addon">
                      參與品牌
                    </span>
                  <v-select v-model="content.bindingBrandList" :options="brandBrief" :multiple="true" class="h-38"></v-select>
                </div>
                <br />
              </div>
            </div>
            <div class="col-xs-12 p-sm-10-p m-x-10 form-left">
              <div>
                <div class="input-group">
                  <span class="input-group-addon">
                    參與店家
                  </span>
                  <v-select v-model="content.bindingStoreList" :options="storeBrief" :multiple="true" class="h-38"></v-select>
                </div>
                <br />
              </div>
            </div>
            -->
            <div class="col-xs-12 p-sm-10-p m-x-10 form-left">
              <h5>參與店家</h5>
              <!-- 參與店家 -->
              <muti-select-two :setting="addStoresSetting"></muti-select-two>
              <!--{{addStoresSetting.choose}}-->
            </div>
            <hr class="box-body col-xs-12">
            <div class="col-xs-12 p-sm-10-p m-x-10 form-left">
              <div>
                <h4>贈送規則</h4>
              </div>
              <div>
                <button class="btn btn-default" data-target="#couponRegisterModal" data-toggle="modal" @click="addCoupon()"> + 贈送優惠券</button>
                <multiselect
                  v-model="otherCoupon"
                  :options="otherCouponList"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="行銷下其他優惠券"
                  label="label"
                  track-by="label"
                  style="width: calc(100% - 130px); display: inline-block;"
                  @select="changeOtherCoupon"
                  @remove="removeOtherCoupon"
                >
                </multiselect>
                <br>
              </div>
              <div v-for="(coupon, index) in couponList" >
                <div style="width: calc(100% - 80px)" class="card m-y-1 pull-left m-y-10 c-pointer" @click="clickCoupon()"data-target="#couponRegisterModal" data-toggle="modal">
                  <div class="coupon-left p-10">
                    <h4>Nidin優惠券</h4>
                    <h5>優惠券描述(備註)</h5>
                    <h5><i class="fa fa-clock"></i>到期：2018-12-29 12:00 ~ 2019-12-22 12:00</h5>
                  </div>
                  <div class="coupon-right p-10">
                    <div class="v-middle">
                      $10
                    </div>
                  </div>
                </div>
                <div class="coupon-edit-block pull-left" v-if="!coupon.code">
                  <button v-if="couponList.length > 1" class="btn btn-danger" @click="couponList.splice(index, 1)"><i class="fa fa-trash"></i></button>
                  <br v-if="couponList.length > 1">
                  <button class="btn btn-default m-t-5"><i class="fa fa-pencil"></i></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.box-body -->
    <div class="box-footer text-center">
      <button class="btn btn-success" @click="crSchedule">
        新增
      </button>
      <button class="btn btn-fail" @click="$router.go(-1)">
        取消
      </button>
    </div>
    <div class="modal fade" id="couponRegisterModal" role="dialog">
      <div class="modal-dialog choose-modal">
        <!-- Modal content-->
        <div class="modal-content pull-left">
          <div class="modal-header pull-left w-100-p">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title text-left">優惠券設定</h4>
          </div>
          <div class="modal-body text-left pull-left">
            <div class="pull-left">
              <div class="card m-y-1 pull-left w-100-p m-y-10 c-pointer">
                <div class="coupon-left p-10">
                  <multiselect
                    v-model="coupon.useType"
                    :options="useType"
                    label="label"
                    :searchable="false"
                    :allow-empty="true"
                    :close-on-select="true"
                    placeholder="優惠券型態"
                    :show-labels="false"
                  >
                  </multiselect>
                  <br>
                  <input class="form-control" placeholder="優惠券名稱">
                  <br>
                  <textarea class="form-control" placeholder="優惠券描述"></textarea>
                  <br>
                  <textarea class="form-control" placeholder="備註"></textarea>
                  <br>
                  <h5 class="text-light-gray m-t-0">
                    使用期限 &nbsp; &nbsp;
                  </h5>
                  <multiselect
                    v-model="coupon.type"
                    :options="deadType"
                    label="label"
                    :searchable="false"
                    :allow-empty="false"
                    :close-on-select="true"
                    placeholder="過期時間種類"
                    :show-labels="false"
                  >
                  </multiselect>
                  <div class="m-t-10 inline-block m-r-10" v-if="coupon.type.value === 1">
                    開始：<date-time-picker :date="menuTime.start" :option="timeoption" :limit="startLimit"></date-time-picker>
                  </div>
                  <div class="m-t-10 inline-block" v-if="coupon.type.value === 1 || coupon.type.value === 2">
                    結束：<date-time-picker :date="menuTime.end" :option="timeoption" :limit="endLimit"></date-time-picker>
                  </div>
                  <div class="m-t-10" v-if="coupon.type.value === 3">
                    <input class="form-control" placeholder="幾天後到期">
                  </div>
                </div>
                <div class="coupon-right p-10">
                  <div>
                    <multiselect
                      v-model="coupon.price_type"
                      :options="priceType"
                      label="label"
                      :searchable="false"
                      :allow-empty="false"
                      :close-on-select="true"
                      placeholder="優惠券稅制"
                      :show-labels="false"
                    >
                    </multiselect>
                    <br>
                  </div>
                  <div>
                    <multiselect
                      v-model="coupon.discount_type"
                      :options="discountType"
                      label="label"
                      :searchable="false"
                      :allow-empty="false"
                      :close-on-select="true"
                      placeholder="優惠券稅制"
                      :show-labels="false"
                    >
                    </multiselect>
                    <br>
                  </div>
                  <div>
                    <input class="form-control" placeholder="面額">
                  </div>
                </div>
              </div>
              <br>
              <div class="pull-left w-100-p">
                <hr>
                <br>
                <multiselect
                  v-model="coupon.setting"
                  :options="couponSetting"
                  label="label"
                  :searchable="false"
                  :allow-empty="false"
                  :close-on-select="true"
                  placeholder="優惠券稅制"
                  :show-labels="false"
                >
                </multiselect>
              </div>
              <div class="pull-left m-t-20">
                <div>
                  <div class="input-group">
                    <span class="input-group-addon">個人訂單最低消費金額</span>
                    <input class="form-control" placeholder="" type="text" v-model="menuName" maxlength="45">
                  </div>
                  <br />
                </div>
                <div>
                  <div class="input-group">
                    <span class="input-group-addon">個人訂單最低消費商品數</span>
                    <input class="form-control" placeholder="" type="text" v-model="menuName" maxlength="45">
                  </div>
                  <br />
                </div>
                <div>
                  <div class="input-group">
                    <span class="input-group-addon">最大使用數量</span>
                    <input class="form-control" placeholder="" type="text" v-model="menuName" maxlength="45">
                  </div>
                  <br />
                </div>
                <div v-if="coupon.setting.value === 1">
                  <div class="input-group">
                    <span class="input-group-addon">商品限制最低單價</span>
                    <input class="form-control" placeholder="" type="text" v-model="menuName" maxlength="45">
                  </div>
                  <br />
                </div>
                <div v-if="coupon.setting.value === 1 || coupon.setting.value === 2">
                  <div class="input-group">
                    <span class="input-group-addon">每商品限用張數</span>
                    <input class="form-control" placeholder="" type="text" v-model="menuName" maxlength="45">
                  </div>
                  <br />
                </div>
                <div v-if="coupon.setting.value === 3">
                  <div class="input-group">
                    <span class="input-group-addon">滿多少的總金額數值</span>
                    <input class="form-control" placeholder="" type="text" v-model="menuName" maxlength="45">
                  </div>
                  <br />
                </div>
                <div v-if="coupon.setting.value === 3">
                  <div class="input-group">
                    <span class="input-group-addon">每達到金額限用的張數</span>
                    <input class="form-control" placeholder="" type="text" v-model="menuName" maxlength="45">
                  </div>
                  <br />
                </div>
                <div v-if="coupon.setting.value === 1 || coupon.setting.value === 3">
                  <div class="input-group">
                    <span class="input-group-addon">排除商品</span>
                    <input class="form-control" placeholder="" type="text" v-model="menuName" maxlength="45">
                  </div>
                  <br />
                </div>
                <div v-if="coupon.setting.value === 2">
                  <div class="input-group">
                    <span class="input-group-addon">指定消費商品</span>
                    <input class="form-control" placeholder="" type="text" v-model="menuName" maxlength="45">
                  </div>
                  <br />
                </div>
                <div>
                  <div class="input-group">
                  <span class="input-group-addon">
                    <span class="text-red">＊ </span>可使用優惠券的訂單類型
                  </span>
                    <div class="form-group">
                      <div class="form-group text-left">
                        <div class="radio inline-block">
                          <label>
                            <input type="radio" name="iconOption" value="0" v-model="orderType">無限制
                          </label>
                        </div>
                        <div class="radio inline-block">
                          <label>
                            <input type="radio" name="iconOption" value="1" v-model="orderType">一般單
                          </label>
                        </div>
                        <div class="radio inline-block">
                          <label>
                            <input type="radio" name="iconOption" value="2" v-model="orderType">團購單
                          </label>
                        </div>
                      </div>
                    </div>
                    <br>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
// Require needed datatables modules
import 'datatables.net'
import 'datatables.net-bs'
import { mapActions } from 'vuex'
import moment from 'moment'
export default {
  components: {
    'date-time-picker': datetimePicker
  },
  data () {
    return {
      activityMethod: 1,
      // modal test
      orderType: '',
      orderMethod: '',
      delivery: '',
      payplace: '',
      memberLimit: [],
      coupon: {
        type: {label: '固定起迄時間', value: 1},
        price_type: {label: '免稅', value: 1},
        discount_type: {label: '折扣金額', value: 1},
        setting: {label: '依訂單購買商品數設定', value: 1},
        useType: {label: '品牌型', value: 1}
      },
      otherCoupon: [],
      // end
      otherCouponList: [
        {label: 'Nidin優惠券', value: 1, code: '1231231dz'},
        {label: '柴犬優惠券', value: 2, code: '324efxde'},
        {label: '你好優惠券', value: 3, code: '654trrgxx'}
      ],
      addStoresSetting: {
        class: 'add-store',
        options: [
          {label: '台北', value: 1},
          {label: '新竹', value: 2},
          {label: '苗栗', value: 3},
          {label: '台中', value: 4},
          {label: '彰化', value: 5},
          {label: '台南', value: 6},
          {label: '高雄', value: 7},
          {label: '屏東', value: 8}
        ],
        choose: []
      },
      deadType: [
        {label: '固定起迄時間', value: 1},
        {label: '固定結束時間', value: 2},
        {label: '發送日幾天後', value: 3}
      ],
      priceType: [
        {label: '免稅', value: 1},
        {label: '未稅', value: 2},
        {label: '含稅', value: 3}
      ],
      discountType: [
        {label: '折扣金額', value: 1}
      ],
      couponSetting: [
        {label: '依訂單購買商品數設定', value: 1},
        {label: '依個人訂單消費特定商品數', value: 2},
        {label: '依個人訂單購買金額', value: 3}
      ],
      memberType: [
        {label: 'FB', value: 1},
        {label: 'Google', value: 2},
        {label: 'LINE', value: 3}
      ],
      useType: [
        {label: '品牌型', value: 1},
        {label: '店家型', value: 2}
      ],
      content: {
        bindingStoreList: [],
        bindingBrandList: []
      },
      brandDefault: '',
      brandBrief: [],
      storeBrief: [],
      oldScheduleTime: '',
      scheduleTime: '',
      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: ''
        }
      },
      show: {
        back: false
      },
      giftSelect: 1,
      tableIndex: 1,
      menuId: 0,
      menuName: '',
      storeId: 0,
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      giftList: [
        {label: '依店家訂單消費金額滿額送', value: 1},
        {label: '依店家訂單商品個數滿額送', value: 2},
        {label: '依店家訂單消費指定商品數量滿額送', value: 3}
      ],
      timeoption: {
        type: 'min',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD HH:mm:ss',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      startLimit: [
        {
          type: 'fromto',
          from: moment().format('YYYY-MM-DD HH:mm:ss')
        }
      ],
      endLimit: [
        {
          type: 'fromto',
          from: moment().format('YYYY-MM-DD HH:mm:ss')
        }
      ],
      info: {
        menuName: '夏日菜單',
        menu_id: 123323,
        start_time: '2017-03-31 12:22:32',
        end_time: '2017-03-31 12:22:32',
        update_time: '2017-03-31 12:22:32',
        create_time: '2017-03-31 12:22:32'
      },
      menu_schedule_list: [
        {
          'schedule_id': 122,
          'store_id': 1,
          'store_name': '金山店',
          'menu_id': 1,
          'start_time': '2017-07-24 08:00:00',
          'end_time': '2017-08-01 00:00:00',
          'status': 1,
          'update_time': '2017-01-14 16:09:16',
          'create_time': '2017-01-14 16:09:16'
        },
        {
          'schedule_id': 123,
          'store_id': 2,
          'store_name': '中山店',
          'menu_id': 2,
          'start_time': '2017-07-24 08:00:00',
          'end_time': '2017-08-01 00:00:00',
          'status': 1,
          'update_time': '2017-01-14 16:09:16',
          'create_time': '2017-01-14 16:09:16'
        }
      ],
      couponList: [
        {name: 'Nidin優惠券'},
        {name: 'Nidin優惠券'}
      ]
    }
  },
  created () {
    this.getBrandBrief()
    // this.getStoreBrief()
    console.log(this.$route.query)
    if (this.$route.name === 'upScheduleOne') {
      this.menuId = this.$route.params.menu_id
      this.storeId = this.$route.params.store_id
    } else if (this.$route.query.menu_id) {
      this.menuId = this.$route.query.menu_id
      this.menuName = this.$route.query.menu_name
    }
  },
  mounted () {
    var self = this
    self.oldScheduleTime = self.scheduleTime = '2015-01-01 01:30:00 - 2015-01-02 01:30:00'
    this.$nextTick(() => {
      // table
      $('#example1_wrapper').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      })
      // daterangepicker
      /*
      $('input[name="daterange"]').daterangepicker({
        // startDate: '2015-01-01 01:30:00',
        // endDate: '2015-01-02 01:30:00',
        autoUpdateInput: false,
        timePicker: true,
        timePickerIncrement: 15,
        locale: {
          format: 'YYYY-MM-DD HH:mm:ss'
        }
      }).on('hide.daterangepicker', function (ev, picker) {
        self.show.back = true
        var start = picker.startDate.format('YYYY-MM-DD HH:mm:ss')
        var end = picker.endDate.format('YYYY-MM-DD HH:mm:ss')
        self.scheduleTime = start + ' - ' + end
        self.menuTime.start = start
        self.menuTime.end = end
      })
      $('.applyBtn').text('確認')
      $('.cancelBtn').text('取消')
      */
    })
  },
  methods: {
    ...mapActions(['setMenuStartTime', 'setMenuEndTime']),
    addCoupon () {
      this.couponList.push({name: 'Nidin優惠券'})
    },
    clickCoupon () {
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    getNewList (index) {
      console.log('LOVE' + index)
    },
    getStoreBrief (brandId) {
      this.storeBrief = []
      var self = this
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
          }
        }
      })
    },
    getBrandBrief () {
      var self = this
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            self.brandBrief.push(obj)
          }
        }
      })
    },
    crSchedule () {
      var self = this
      var data = {
        store_id: [],
        menu_id: self.menuId,
        start_time: self.menuTime.start.time,
        end_time: self.menuTime.end.time
      }
      self.content.bindingStoreList.forEach(function (store) {
        data.store_id.push(store.value)
      })
      var url = '/brand/' + this.$route.params.brand_id + '/menu/schedule/group'
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          console.log(response.data)
          self.$notify({
            title: '提醒',
            text: '新增菜單成功',
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.replace('/brandScheduleTable/' + self.$route.params.brand_id)
        }
      })
    },
    changeOtherCoupon (current) {
      this.couponList.push(current)
      console.log(current)
    },
    removeOtherCoupon (current) {
      var self = this
      var removeId = ''
      this.couponList.find(function (coupon, index) {
        if (coupon.code) {
          if (current.code === coupon.code) {
            console.log(index)
            removeId = index
            return
          }
        }
      })
      if (removeId) self.couponList.splice(removeId, 1)
    }
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    scheduleListNew () {
      var menuList = {}
      var oldList = this.menu_schedule_list
      for (var key in oldList) {
        // console.log(oldList[key].menu_id)
        menuList[oldList[key].menu_id] = {
          menu_id: oldList[key].menu_id,
          storeList: []
        }
      }
      for (var k in oldList) {
        menuList[oldList[k].menu_id].storeList.push({
          store_id: oldList[k].store_id,
          store_name: oldList[k].store_name,
          start_time: oldList[k].start_time,
          end_time: oldList[k].end_time,
          status: oldList[k].status,
          update_time: oldList[k].update_time,
          create_time: oldList[k].create_time,
          schedule_id: oldList[k].schedule_id
        })
      }
      return menuList
    },
    getList () {
      // var num = 0
      if (this.$route.name === 'upScheduleOne') {
        var oneList = this.scheduleListNew[this.menuId].storeList
        this.menuTime.start.time = oneList[0].start_time
        this.menuTime.end.time = oneList[0].end_time
        return oneList
      } else {
        var list = []
        for (var key in this.scheduleListNew) {
          for (var k in this.scheduleListNew[key].storeList) {
            list.push(this.scheduleListNew[key].storeList[k])
          }
        }
        return list
      }
    }
  },
  watch: {
    'menuTime.start.time' () {
      this.endLimit = [
        {
          type: 'fromto',
          from: this.menuTime.start.time
        }
      ]
      this.setMenuStartTime(this.menuTime.start.time)
    },
    'menuTime.end.time' () {
      this.startLimit = [
        {
          type: 'fromto',
          from: moment().format('YYYY-MM-DD HH:mm:ss'),
          to: this.menuTime.end.time
        }
      ]
      this.setMenuEndTime(this.menuTime.end.time)
    },
    'content.bindingBrandList' () {
      var self = this
      this.storeBrief = []
      this.content.bindingStoreList = []
      this.content.bindingBrandList.forEach(function (array) {
        const brandId = array.value
        self.getStoreBrief(brandId)
      })
    }
  }
}
</script>
<style lang="sass">
.coupon-left
  float: left
  width: calc(100% / 3 * 2 + 15px)
.coupon-right
  float: left
  background: #3c8dbc
  width: calc(100% / 3 - 15px)
  position: absolute
  right: 0
  top: 0
  height: 100%
  border-left: 5px black dashed
  border-radius: 0px 6px 6px 0px
  color: white
  .v-middle
    position: absolute
    top: calc(50% - 28.5px)
    font-size: 40px
    text-align: center
    width: 100%
    left: 0
</style>
<style lang="sass" scoped>
// .ranges
  display: none
.min-item.active, .hour-item.active, .day.checked
  background: #222d32 !important
.w-200
  width: 180px !important
.m-b-15
  margin-bottom: 15px !important
.btn-all-store
  position: absolute
  right: 10px
  z-index: 30
  top: 0px
.input-white
  border: 0px
@media screen and (max-width: 767px)
  .p-sm-10-p
    padding-right: 10px !important
    padding-left: 10px !important
@media screen and (min-width: 768px)
  .p-sm-10-p
    padding-right: calc(20% - 15px) !important
    padding-left: calc(20% + 10px) !important
@media screen and (min-width: 991px)
  .p-sm-10-p
    padding-right: calc(10% - 10px) !important
    padding-left: 10% !important
</style>
<style lang="sass">
  .coupon-edit-block
    top: 0
    margin: 30px 0px 0px 10px
    display: inline-block
  .multiselect__content-wrapper, .multiselect__content-wrapper *
    z-index: 99
  .m-t-0
    margin-top: 0px
  .input-group .form-control
    z-index: auto !important
  textarea
    max-width: 100%
    min-widht: 100%
  .modal-title
    width: calc(100% - 20px)
  @media screen and (max-width: 767px)
    .input-group.cr-schedule .cov-vue-date .cov-datepicker
      width: calc(100vw - 185px)
  @media screen and (min-width: 768px)
    .input-group.cr-schedule .cov-vue-date .cov-datepicker
      width: calc(50vw - 190px)
  @media screen and (min-width: 991px)
    .input-group .cov-vue-date .cov-datepicker
      max-width: calc(30vw - 190px)
</style>



// WEBPACK FOOTER //
// ActivityRegisterForm.vue?d6fa5ac6